// @flow
import { connect } from 'react-redux';

import { fetchAllContactForm7Forms } from 'actions/contactForm7Actions';
import ContactAndFaqSelector from 'components/contact/ContactAndFaqSelector';
import type { DispatchProps, StateProps } from 'components/contact/ContactAndFaqSelector';
import type { DispatchType, StateType } from 'types/Actions';

const mapStateToProps = (state: StateType): StateProps => ({
  contactFormList: state.contactForm7State.contactFormList
});

const dispatchStateToProps = (dispatch: DispatchType): DispatchProps => ({
  fetchAllContactForms: () => dispatch(fetchAllContactForm7Forms())
});

export default connect(mapStateToProps, dispatchStateToProps)(ContactAndFaqSelector);
